export default {
  NORMAL: 'normal',
  TABLE_GAMES: 'tableGames',
  VIP_GAMES: 'vipGames',
  FAVOURITES: 'favourites',
  UPDATE_TERMS: 'updateTerms',
  SPORTS_GAMES: 'sportsGames'
};